import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ViewController
} from "ionic-angular";
import * as papa from "papaparse";
import { DatabaseProvider } from '../../providers/database/database';
import * as _ from "lodash";
import { AuthProvider } from "../../providers/auth/auth";
import * as moment from 'moment';

@IonicPage()
@Component({
  selector: "page-patient-upload",
  templateUrl: "patient-upload.html"
})
export class PatientUploadPage {
  uploadedPatients: Array<Object> = [];
  message: string = null;
  clinic_name: string = null;
  clinic_id: string = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    private viewCtrl: ViewController
  ) {

    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });
  }

  parseCSV(files: FileList): void {
    let loading = this.loadingCtrl.create({
      content: "Uploading and checking patient info..."
    });

    loading.present().then(_ => {
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = e => {
        const csv = reader.result;
        //const parsed = papa.parse(csv, {
        papa.parse(csv, {
          // dynamicTyping: true,
          header: true,
          complete: () => {
            console.log("Completed Data", this.uploadedPatients);
            loading.dismiss();
          },
          error: error => {
            console.error(error.message);
            loading.dismiss();
          },
          step: row => {
            console.log('Row: ', row)
            // Add Fullname
            row.data[0]["full_name"] = row.data[0]["first_name"] + ' ' + row.data[0]["last_name"];

            // Fix 2 digit date problem
            if(row.data[0]["dob"])  {
            console.log("Original DOB: ", moment(row.data[0]["dob"]).format('YYYY-MM-DD'));
          //   let datearray = row.data[0]["dob"].split("-");
          //   let day = datearray[0];
          //   let month = datearray[1];
          //   let year = datearray[2];
          //   if(year.length < 3) {
          //   if(parseInt("20" + year) < parseInt((new Date()).getFullYear().toString())) {
          //     year = "20" + year;
          //   }
          //   else {
          //     year = "19" + year;
          //   }
          // }
          //   let newdatestring = year + '-' + month + '-' + day;
          
           // console.log("New Date String: ", moment(row.data[0]["dob"]).format('YYYY-MM-DD'));
            let newDOB = moment(row.data[0]["dob"]).format('YYYY-MM-DD')
            
            row.data[0]["dob"] = newDOB;
            console.log("New DOB: ", row.data[0]["dob"]);

            let gender = row.data[0]["gender"]
            if (gender === 'M' || gender === 'Male' || gender === 'MALE' || gender === 'male') {
              row.data[0]["gender"] = "MALE";
            } else {
              row.data[0]["gender"] = "FEMALE";
            }
        }
            // do phone number
            //let phone = row.data[0]["phone_number"]

            //row.data[0]["phone_number_primary"] = phone;
            //console.log("Phone Number: ", row.data[0]["phone_number"]);

            // update email address
            //let email = row.data[0]["email"]

            // push patient to array
            this.uploadedPatients.push(row.data[0]);
            //console.log(row.meta.cursor / csv.size * 100);
          }
        });
        //this.uploadedPatients = parsed.data;
        // do something with parsed CSV
      };
    });
  }

  completeUpload() {
    let confirm = this.alertCtrl.create({
      title: "Add Patients?",
      message:
        "Are you sure you would like to add " +
        this.uploadedPatients.length +
        " patients?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't upload patients");
          }
        },
        {
          text: "Yes",
          handler: () => {
            _.forEach(this.uploadedPatients, async row => {
              console.log('Upload Started');
              await this.savePatient(row);
              console.log('Upload Finished');
            });
          }
        }
      ]
    });
    confirm.present();
  }

  async savePatient(row) {
    return new Promise(async (resolve, reject) => {
    console.log('Start FS Write');
    await this.database
      .addPatient(this.clinic_id, row)
      .then(response => {
        console.log("Write OK to FS", response);
        resolve(true);
      })
      .catch(err => {
        console.log("Write Error to FS", err);
        reject(false);
      });
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-upload/patient-upload.ts